import React, { memo } from 'react';

import { SmartCreateFeedbackBannerLoader } from '@confluence/editor-action-bar/entry-points/SmartCreateFeedbackBannerLoader.ts';

export type FullPageEditorBannerWrapperProps = {
	isLivePage: boolean;
	spaceKey: string;
};

export const FullPageEditorBannerWrapper: React.MemoExoticComponent<
	({ isLivePage, spaceKey }: FullPageEditorBannerWrapperProps) => React.JSX.Element | null
> = memo(({ isLivePage, spaceKey }: FullPageEditorBannerWrapperProps): React.JSX.Element | null => {
	if (spaceKey !== 'XFLOW' && !isLivePage) {
		return <SmartCreateFeedbackBannerLoader contentType="page" />;
	}

	return null;
});
